export default "__VITE_ASSET__d033f313__"